module.exports = __webpack_public_path__ + "static/media/first-website-home.af84f837.jpg";